import { ButtonLink } from '@/components/ui/Button'
import { Section } from '@/components/ui/Section'
import { BrandMark } from '@/components/visuals'
import { ROUTES } from '@/config/site'
import { useDocumentMeta } from '@/hooks/useDocumentMeta'
import { useI18n } from '@/i18n'

export function NotFoundPage() {
  const { t } = useI18n()
  useDocumentMeta({ title: t.notFound.title })

  return (
    <Section size="narrow" className="text-center">
      <BrandMark className="mx-auto w-20" />
      <h1 className="mt-8 text-4xl">{t.notFound.title}</h1>
      <p className="mt-3 text-muted">{t.notFound.lead}</p>
      <div className="mt-8">
        <ButtonLink to={ROUTES.home}>{t.common.backHome}</ButtonLink>
      </div>
    </Section>
  )
}
